<template>
  <label class="mo-upload">
    <input
      type="file"
      :accept="accepts"
      @change="upload"
    >
    <slot></slot>
  </label>
</template>

<script>
export default {
  name: "MoUpload",
  props: {
    accepts: {
      //允许的上传类型
      type: String,
      default: "image/jpeg,image/jpg,image/png"
    },
    flag: [String, Number], //当前上传标识,以便于在同一个监听函数中区分不同的上传域
    maxSize: {
      type: Number,
      default: 0 //上传大小限制
    },
    action: {
      type: String
    },
    beforeUpload: {
      type: Function
    },
    idx: {
      type: Number
    },
    id: {
      type: String
    },
    overtimeFn: {
      type: Function
    },
    uploadKey: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  methods: {
    upload(event) {
      let file = event.target.files[0];
      const _this = this;
      const flag = this.flag;
      if (file) {
        if (!_this.beforeUpload(file, event)) {
          return;
        }
        //filter file, 文件大小,类型等过滤
        //如果是图片文件
        // const reader = new FileReader()
        // const imageUrl = reader.readAsDataURL(file)
        // img.src = imageUrl //在预览区域插入图片

        const formData = new FormData();

        formData.append("file", file);

        _this.$http
          .post(this.action, formData)
          .then(response => {
            const result = response.body;
            //传递给父组件的complete方法
            _this.$emit(
              "complete",
              result,
              file,
              _this.idx,
              _this.id,
              this.uploadKey
            );
            //让当前target可以重新选择
            event.target.value = null;
          })
          .catch(() => {
            if (this.overtimeFn) this.overtimeFn();
          });
      }
    }
  }
};
</script>
<style lang="less">
.mo-upload {
  display: inline-block;
  position: relative;
  margin-bottom: 0;
  input[type="file"] {
    display: none;
  }
  .mo-upload--label {
    display: inline-block;
    position: relative;
  }
}
</style>


// WEBPACK FOOTER //
// file_upload.vue?13cd8380